var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"pa-0":""}},[_c('v-layout',{attrs:{"justify-center":"","pa-0":""}},[_c('deviceInfo')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }